export enum DeviceTypeEnum {
    WHOOP = 'WHOOP',
}
